module.exports = __webpack_public_path__ + "images/average-rating-black-cc10b4e9.svg";